import { render, staticRenderFns } from "./1v1card.vue?vue&type=template&id=73437396&scoped=true&"
import script from "./1v1card.vue?vue&type=script&lang=js&"
export * from "./1v1card.vue?vue&type=script&lang=js&"
import style0 from "./1v1card.vue?vue&type=style&index=0&id=73437396&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73437396",
  null
  
)

export default component.exports